import * as React from "react";
const SvgFiBrandsIconfinder = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 25 24"
    {...props}
  >
    <g fill="#151A2D" clipPath="url(#fi-brands-iconfinder_svg__a)">
      <path d="M12.5 10.04a4.1 4.1 0 0 0-1.51.29c.635.21 1.083.79 1.083 1.47 0 .86-.73 1.55-1.615 1.55a1.62 1.62 0 0 1-1.53-1.04 3.6 3.6 0 0 0-.303 1.46c0 2.06 1.74 3.73 3.885 3.73 2.146 0 3.886-1.67 3.886-3.73s-1.74-3.73-3.886-3.73z" />
      <path d="M17.75 5.68a10.32 10.32 0 0 0-8.49-.92 8.45 8.45 0 0 1 4.875-1.52c1.021 0 1.99.15 2.886.48.062.02.135.03.166.03.22 0 .375-.14.375-.34 0-.14-.072-.25-.156-.33C15.031.96 12.5.09 12.5.09 6.844 2.26 2.687 7.51 2.573 13.51a9.2 9.2 0 0 0 1.323 5.03 9.4 9.4 0 0 0 2.083 2.43 8.2 8.2 0 0 1-3.812-3.29c-.51-.85-.855-1.73-1.01-2.64-.011-.06-.042-.13-.053-.16a.36.36 0 0 0-.5-.14.46.46 0 0 0-.219.3c-.708 3.04-.229 5.58-.229 5.58 4.854 3.67 11.792 4.47 17.302 1.42 2.594-1.44 4.25-3.82 4.782-6.44a7.72 7.72 0 0 1-1.063 4.82 7.9 7.9 0 0 1-1.875 2.16c-.052.04-.094.1-.114.12-.105.18-.063.38.125.48.125.07.26.07.375.03 3.093-.93 5.145-2.6 5.145-2.6.865-5.77-1.77-11.83-7.093-14.93zM12.5 19.99c-4.531 0-8.208-3.05-8.208-6.81 0-.4.041-.79.125-1.18 1.698-1.68 4.687-2.79 8.083-2.79s6.375 1.11 8.083 2.79c.084.38.125.77.125 1.18 0 3.76-3.677 6.81-8.208 6.81" />
    </g>
    <defs>
      <clipPath id="fi-brands-iconfinder_svg__a">
        <path fill="#fff" d="M0 0h25v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiBrandsIconfinder;
